import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CRMService } from '../../services/crm.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    OpportunityQuestionCategory
} from '../../models/models';

@Component({
    selector: 'opportunity-question-category-form',
    templateUrl: './opportunity-question-category-form.component.html',
    standalone: false
})
export class OpportunityQuestionCategoryForm implements OnChanges {
    @Input() tableID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public tableItem: OpportunityQuestionCategory = {} as OpportunityQuestionCategory;

    constructor(private crmService: CRMService, private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnChanges() {
        this.getTableItem();
        //console.log("ngOnChanges", this.tableID, this.carrierID);
    }

    private getTableItem() {
        if (this.tableID > 0) {
            this.crmService.getOpportunityQuestionCategoryByID(this.tableID).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.tableItem = result.resultCollection[0];
                }
            });
        }
        else {
            //var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.tableItem = {
                opportunityQuestionCategoryID: 0,
                description: "",
                abbreviation: "",
                sortOrder: 0,
                retired: false
            };
        }
    }

    public save() {
        this.utilService.isLoading = true;
        console.log("save", this.tableItem);
        this.crmService.saveOpportunityQuestionCategory(this.tableItem).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                this.onRefresh.emit();
            }
        });

        this.tableItem = {} as OpportunityQuestionCategory;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}